/**
 * This function returns a list of unique ids to be used for checkboxes selections
 * @param {array} source - Selection source
 * @param {string} value - Value to be checked
 * @returns {array} Unique selection list
 */
export const uniqueSelection = (source, value) => {
    let selection = new Set(source);
    if (!selection.has(value)) {
        selection.add(value);
    } else {
        selection.delete(value);
    }
    return [...selection];
};

/**
 * This function performs a global selection on a given list
 * @param {array} source - A list of objects
 * @param {array} ids - A list of ids for comparison
 * @returns {array} Either a full selection, or none
 */
export const multipleSelection = (source, ids) => {
    const allSelected = ids.every(id => source.includes(id));
    return allSelected ? [] : ids;
};

/**
 * This function performs a unique or global selection on a given list, depending on parameters
 * @param {array} source - A list of objects
 * @param {array} ids - A list of ids for comparison
 * @param {string} value - Value to be checked
 * @returns {array} If value is passed, unique selection list. Else, either a full selection, or none.
 */
export const listSelection = (source, ids, value) => {
    if (!source) {
        throw new Error('[listSelection] source is mandatory');
    }
    if (!value) {
        return multipleSelection(source, ids);
    }
    return uniqueSelection(source, value);
};

export const resolve = (value, fallback) => {
    if (!value) {
        return fallback;
    }
    return value;
};
